import axios from 'axios';

const urlVFI = "https://us-central1-vida-anahuac.cloudfunctions.net/checkEventVFIPassRequest";
const VFIComplete  = "https://us-central1-vida-anahuac.cloudfunctions.net/markAsCompletedVFIPassRequest";
const VFICreate = "https://us-central1-vida-anahuac.cloudfunctions.net/checkAndInsertEventVFIPassRequest";
export default class VFIService {

    async checkVFIIntends(userEmail) {

        const result = await axios.post(
            urlVFI,
            {
                notification: {
                    id: userEmail
                }
            }
        );

        if (result.data.valid) 
        return true;

        return false;
    }

    async markVFIComplete(eventId, email) {
        await axios.post(
            VFIComplete,
            {
                student: {
                    id: email,
                },
                event: {
                    id: eventId
                }
            }
        );
    }


    async createVFIRecord(data) {
        await axios.post(
            VFICreate,
            {
               ...data
            }
        );
    }
}